import { toastError, toastSuccess } from 'admination-react'
import { useEffect, useRef, useState } from 'react'

import { useApp } from '@/core/state/appStore'
import { storeUploadedDoc } from '@/core/data/dokumente'
import { UPLOAD_ACCEPT } from '@/core/lib/fileTypes'
import { DropCard } from '../DropCard'
import { ModalHeader } from '../ModalHeader'

export const HOCHLADEN_MAX_BYTES = 10 * 1024 * 1024

export function DokumentHochladen({ coachingId }: { coachingId: string | null }) {
  const { state, dispatch, reloadDashboard } = useApp()
  const name = state.screen?.document.name ?? null
  const [laedt, setLaedt] = useState(false)
  const mountedRef = useRef(true)
  useEffect(() => {
    mountedRef.current = true
    return () => {
      mountedRef.current = false
    }
  }, [])

  async function hochladen(file: File) {
    if (!coachingId || !name) return
    if (file.size > HOCHLADEN_MAX_BYTES) {
      toastError('Die Datei ist zu groß – höchstens 10 MB.')
      return
    }
    setLaedt(true)
    try {
      await storeUploadedDoc(coachingId, name, file)
      toastSuccess(`${name} gespeichert`)
      reloadDashboard()
      dispatch({ type: 'CHANGE_PHASE', target: { modal: 'personal', tab: 'dokumente' } })
    } catch (e) {
      console.error(`${name} speichern fehlgeschlagen:`, e)
      toastError(`${name} konnte nicht gespeichert werden.`)
    } finally {
      if (mountedRef.current) setLaedt(false)
    }
  }

  return (
    <>
      <ModalHeader
        title={name ?? ''}
        size="document"
       onClose={() => dispatch({ type: 'DISMISS' })} closeTestId="dokument-hochladen-schliessen" />
      <DropCard
        testId="dokument-hochladen"
        title={`${name ?? ''} hier ablegen`}
        body="Die Datei als PDF, JPG oder PNG auswählen oder hierher ziehen – höchstens 10 MB."
        accept={UPLOAD_ACCEPT}
        onFile={(file) => void hochladen(file)}
        loading={laedt}
        loadingLabel={`${name ?? ''} wird gespeichert …`}
      />
    </>
  )
}
